import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { useMemo, useState } from "react";
import { formatDateTime } from "../../../../algorithms/date";
import {
  Button,
  ImageTilePicker,
  Modal,
  Select,
  Textfield,
} from "../../../../components/core";
import { Button as PrimereactButton } from "primereact/button";
import RadioButtonV2 from "../../../../components/core/checkbox-v2";
import { InputTextarea } from "primereact/inputtextarea";
import { useQuery } from "@apollo/client";
import { OPERATOR_ACCOUNTS_BY_FILTER } from "../../../../constants/graphql/auth-queries";
import axios from "axios";
import { Strings } from "../../../../constants/strings";

const RefundDialog = ({
  visible = false,
  onClose,
  setUpdatedPaymentData,
  header,
  paymentData,
  packageData,
  dropdownOptions = [
    { label: "Option 1", value: 1 },
    { label: "Option 2", value: 2 },
  ],
  onChange,
  updatedPaymentData = {},
}) => {
  // env variablessss
  const MBOX_DOMAIN = `${process.env.REACT_APP_MBOX_FRESHDESK_API}`;
  const MBOX_API = `${process.env.REACT_APP_MBOX_FRESHDESK_API_KEY}`;
  const MBOX_TICKET_FRESHDESK = `${process.env.REACT_APP_MBOX_FRESHDESK_DOMAIN}`;
  const CURRENT_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

  // local Variables
  const [isEditingPaymentAmount, setIsEditingPaymentAmount] = useState(false);
  const [updatedPaymentDataState, setUpdatedPaymentDataState] = useState({
    paymentAmount: paymentData.paymentAmount,
    paymentCurrency: paymentData.paymentCurrency,
    isEditing: false,
  });
  console.log({ packageData, paymentData });
  const [invalidTicket, setInvalidTicket] = useState(false);
  const [refundRequest, setRefundRequest] = useState({
    freshdeskTicketNumber: "",
    customerName: "",
    lockerAddress: packageData.lockerLocation,
    totalAmountPaid: paymentData.paymentAmount,
    paymentCurrency: paymentData.paymentCurrency,
    paymentId: paymentData.paymentId,
    paymentFor: "",
    paymentChannel: paymentData.paymentCurrency === "PHP" ? -1 : 5, // Use default first
    proofOfPayment: [],
    refundMethod: -1,
    refundType: "full",
    refundAmount: paymentData.paymentAmount, // Set to full amount initially
    refundReason: "",
    customerRefundDetails: {
      name: "",
      bankAccountNumber: "",
    },
    personnelDetails: {
      username: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).username
        : "",
      email: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).email
        : "",
    },
    requestedOn: formatDateTime(new Date()),
    approvedBy: -1,
  });
  const [changesMade, setChangesMade] = useState(false);
  const [imageKeys, setImageKeys] = useState({
    proofOfPayment: 0,
    idPhoto: 0,
  });
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  // gql
  // query accounts with role === Tech for approval options
  const techTeamOptions = useQuery(OPERATOR_ACCOUNTS_BY_FILTER, {
    variables: {
      operatorId: 1,
      active: true,
      operatorAccountRoleId: CURRENT_ENVIRONMENT === "test" ? 1 : 2,
    },
  });

  const techTeam = useMemo(() => {
    if (techTeamOptions.data && techTeamOptions.data.operatorAccountsByFilter) {
      return techTeamOptions.data.operatorAccountsByFilter.map((item) => ({
        value: item.operatorAccountId,
        name: `${item.username} (${item.userEmail})`,
      }));
    }
  }, [techTeamOptions.data]);
  const refundBankOptions = [
    { value: 5, name: "MBOX" },
    {
      value: 1,
      name: "Gcash",
    },
    {
      value: 2,
      name: "Maya",
    },
    {
      value: 3,
      name: "ShopeePay",
    },
    {
      value: 4,
      name: "HelloMoney",
    },
  ];

  // const approvalOptions = [{
  //   value: 1,
  //   name: "Pong "
  // }]

  const closeConfirmPaymentRefund = () => {
    setUpdatedPaymentDataState({
      ...updatedPaymentDataState,
      isEditing: false,
      paymentAmount: paymentData.paymentAmount,
      paymentCurrency: paymentData.paymentCurrency,
    });
    setIsEditingPaymentAmount(false);
    setUpdatedPaymentData({
      ...updatedPaymentData,
      paymentAmount: paymentData.paymentAmount,
      paymentCurrency: paymentData.paymentCurrency,
    });
  };

  function validateFileType(file) {
    const allowedTypes = ["image/jpeg", "image/jpg"];
    return allowedTypes.includes(file.type);
  }

  function imageToBase64(files, name, event) {
    if (files) {
      const file = files[0];

      // Validate file type
      if (!validateFileType(file)) {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
          title: "Image Error",
          message: `Selected image must strictly be a jpg/jpeg`,
          open: true,
          actions: (
            <div className="w-full">
              <Button
                onClick={() => setValidation({ open: false })}
                value={"OK"}
                className={"p-2 w-full"}
              />
            </div>
          ),
        });
        // URL.revokeObjectURL(objectUrl);
        // e.target.value = null;

        // Clear the file input
        event.target.value = "";
        // Force re-render of ImageTilePicker by changing its key
        setImageKeys((prev) => ({
          ...prev,
          [name]: prev[name] + 1,
        }));
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        // The result property contains the base64 encoded data
        const base64String = event.target.result;
        // setProofPhoto((prev) => ({
        //   ...prev,
        //   [name]: base64String,
        // }));
        setRefundRequest({
          ...refundRequest,
          proofOfPayment: base64String,
        });
      };

      // Read the file as a data URL (base64 encoded)
      reader.readAsDataURL(file);
    } else {
    }
  }

  // Helper function at the top of your component
  const setValue = (obj, path, value) => {
    const keys = path.split(".");
    const result = { ...obj };
    let current = result;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      current[key] = { ...current[key] };
      current = current[key];
    }

    current[keys[keys.length - 1]] = value;
    return result;
  };

  const handleRefundRequestChange = (e, field) => {
    const { value } = e.target;
    console.log({ field, value, E: e.target.value });

    if (field === "refundAmount") {
      var numberPattern = /^\d+(\.\d{0,2})?$/;
      if (numberPattern.test(value) || value === "") {
        if (parseFloat(value) <= 1000000000 || value === "") {
          setRefundRequest((prev) => setValue(prev, field, value));
        }
      }
    } else {
      if (field === "refundType") {
        setRefundRequest((prev) => {
          const newState = setValue(prev, field, value);
          return setValue(newState, "refundAmount", "");
        });
      } else {
        if (field === "freshdeskTicketNumber") {
          ticketExisting(value).then((ticketExists) => {
            if (!ticketExists) {
              // Call your error dialog here for invalid ticket
              // showErrorDialog("Ticket not found in Freshdesk");
              setInvalidTicket(true);
            } else {
              setInvalidTicket(false);
            }
          });
        }
        setRefundRequest((prev) => setValue(prev, field, value));
      }
    }

    setChangesMade(true);
  };

  const getSelectedBankName = (value) => {
    const intValue = parseInt(value);

    switch (intValue) {
      case 1:
        return "Gcash";
      case 2:
        return "Maya";
      case 3:
        return "ShopeePay";
      case 4:
        return "HelloMoney";
      case 5:
        return "MBOX";
      default:
        return "Unknown Bank";
    }
  };

  const ticketExisting = async (ticketId) => {
    try {
      const response = await axios.get(`${MBOX_DOMAIN}${ticketId}`, {
        headers: {
          Authorization: `Basic ${btoa(MBOX_API + ":X")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        // Ticket exists
        // showSuccess("Ticket exists in Freshdesk.", () => {
        //   window.open(`${MBOX_DOMAIN}${ticketId}`);
        // });
        // setIsClicked(false);
        return true;
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn("Ticket not found:", error);
      } else {
        console.error("Error retrieving ticket:", error);
      }
      // setIsClicked(false);
      return false;
    }
  };

  const validateFields = () => {
    const emptyFields = [];

    // Define required fields that should exist in your state
    const requiredFields = [
      "freshdeskTicketNumber",
      "customerName",
      "paymentFor",
      "proofOfPayment",
      "refundMethod",
      "refundReason",
      "approvedBy",
    ];

    // Only check fields that actually exist in your state
    requiredFields.forEach((key) => {
      if (key in refundRequest) {
        const value = refundRequest[key];

        if (
          !value ||
          value === "" ||
          value === -1 ||
          (Array.isArray(value) && value.length === 0)
        ) {
          emptyFields.push(key);
        }
      }
    });

    // Check nested fields
    if (!refundRequest.customerRefundDetails?.name) {
      emptyFields.push("customerRefundDetails.name");
    }

    if (!refundRequest.customerRefundDetails?.bankAccountNumber) {
      emptyFields.push("customerRefundDetails.bankAccountNumber");
    }

    if (emptyFields.length > 0) {
      console.log({ emptyFields });
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: `${Strings.popup_error_title}`,
        message: `${Strings.popup_error_message_empty_field}`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return false;
    }

    return true;
  };
  return (
    <>
      {" "}
      <Dialog
        visible={visible}
        onHide={onClose}
        header="Payment Refund"
        headerClassName="text-secondary-purpleGray font-bold"
        className="w-[550px]"
        closable={true}
        resizable={false}
        draggable={false}
      >
        <div className="text-secondary-purpleGray ">
          <div className="grid grid-cols-12 space-y-2 bg-gray-100 shadow-md p-4 rounded-lg">
            <div className="col-span-12 pb-2 text-left uppercase font-semibold">
              Package Payment Details
            </div>
            <div className="col-span-12 items-center">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal  ">Payment Date:</div>
                <div className="col-span-1 font-semibold text-right">
                  {formatDateTime(paymentData.paymentDate)}
                </div>
              </div>
            </div>

            <div className="col-span-12 items-center">
              <div className="grid grid-cols-2 items-center">
                <div className="col-span-1 font-normal  ">
                  Total Payment Amount:
                </div>
                <div className="col-span-1 items-center">
                  <div className="grid grid-cols-5 items-center">
                    <div className="col-span-5 text-right font-semibold">
                      {paymentData.paymentCurrency === "PHP" ? "₱" : ""}
                      {paymentData.paymentAmount}
                      {paymentData.paymentCurrency === "PHP"
                        ? ""
                        : " MBOX COINS"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-span-12 items-center">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal">Payment ID:</div>
                <div className="col-span-1 font-semibold text-right">
                  {paymentData.paymentId}
                </div>
              </div>
            </div>
          </div>

          {/* <Divider className="border border-gray-200"></Divider> */}

          <div className="grid grid-cols-12 space-y-2 bg-gray-100 shadow-md p-4 rounded-lg mt-4">
            <div className="col-span-12 pb-2 text-left uppercase font-semibold">
              Package Details
            </div>
            <div className="col-span-12">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal  ">Locker Location:</div>
                <div className="col-span-1 font-semibold text-right">
                  {packageData.lockerName}
                </div>
              </div>
            </div>

            <div className="col-span-12">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal">Service:</div>
                <div className="col-span-1 font-semibold text-right">
                  {packageData.service}
                </div>
              </div>
            </div>

            <div className="col-span-12">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal ">Waybill Number:</div>
                <div className="col-span-1 font-semibold text-right">
                  {packageData.waybillNumber}
                </div>
              </div>
            </div>

            <div className="col-span-12">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal">Recipient Mobile:</div>
                <div className="col-span-1 font-semibold text-right">
                  {packageData.recipientMobile}
                </div>
              </div>
            </div>

            <div className="col-span-12">
              <div className="grid grid-cols-2">
                <div className="col-span-1 font-normal  ">Agent Mobile:</div>
                <div className="col-span-1 text-right font-semibold">
                  {packageData.partnerAgentMobile}
                </div>
              </div>
            </div>
          </div>

          <div className="pt-8 flex justify-center">
            <PrimereactButton
              label="Create Refund Request"
              size="small"
              className="bg-primary-primaryYellow p-3 text-sm hover:bg-primary-primaryYellowDark"
              onClick={() => {
                setIsEditingPaymentAmount(true);
              }}
            />
          </div>
        </div>
        {/*  */}
      </Dialog>
      {/* confirm refund dialog */}
      <Dialog
        visible={isEditingPaymentAmount}
        header="Submit Refund Request to Accounting"
        closable={false}
        headerClassName="text-secondary-purpleGray"
        resizable={false}
        draggable={false}
        className="w-[750px]  "
        footer={
          <div className="flex justify-center gap-2 items-center mt-4 text-secondary-purpleGray">
            <div>
              <PrimereactButton
                className="p-3 border border-primary-primaryYellow
            hover:bg-slate-100 text-sm"
                size="small"
                onClick={() => {
                  closeConfirmPaymentRefund();
                }}
              >
                Cancel
              </PrimereactButton>
            </div>
            <div>
              <PrimereactButton
                disabled={!changesMade}
                className="p-3 border-0 bg-primary-primaryYellow
            hover:bg-primary-primaryYellowDark text-sm"
                label="Submit Refund Request"
                size="small"
                onClick={validateFields}
              />
            </div>
          </div>
        }
      >
        <>
          <div className="grid grid-cols-12 spacey-1">
            {/* transaction details section */}
            <>
              <div className="col-span-12 space-y-2">
                <div className="text-lg text-left text-secondary-purpleGray font-semibold py-2 rounded-md uppercase tracking-wide">
                  Transaction Details
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Freshdesk Ticket Number
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield
                          value={refundRequest.freshdeskTicketNumber}
                          maxLength={10}
                          className={`${
                            invalidTicket
                              ? "border-1 border-red-500 w-full"
                              : "w-full"
                          }`}
                          isNumberOnly={true}
                          onChange={(e) => {
                            handleRefundRequestChange(
                              e,
                              "freshdeskTicketNumber"
                            );
                          }}
                        />
                      </span>
                    </div>
                  </div>

                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Customer Name<span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield
                          value={refundRequest.customerName}
                          maxLength={100}
                          isNumberOnly={false}
                          placeholder="Enter customer name"
                          onChange={(e) => {
                            handleRefundRequestChange(e, "customerName");
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  {refundRequest.freshdeskTicketNumber !== "" ? (
                    invalidTicket ? (
                      <div className="col-span-8 text-[14px] pt-2 italic text-red-500">
                        Ticket not found in Freshdesk
                      </div>
                    ) : (
                      <div className="col-span-8 text-[14px] pt-2 italic text-green-500">
                        Ticket verified ✓
                      </div>
                    )
                  ) : null}
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Locker Address<span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield
                          disabled
                          value={packageData.lockerLocation}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Payment ID<span className="text-red-500">* </span>
                      </span>
                      <span className="col-span-7">
                        <Textfield disabled value={paymentData.paymentId} />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Total Amount Paid
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield disabled value={paymentData.paymentAmount} />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Payment Currency
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield
                          disabled
                          value={
                            paymentData.paymentCurrency === "PHP"
                              ? "PHP"
                              : "MBOX COINS"
                          }
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Payment Channel
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Select
                          items={refundBankOptions}
                          disabled={paymentData.paymentCurrency !== "PHP"}
                          defaultOption={{
                            value: -1,
                            name: "-- Select payment channel --",
                          }}
                          // AUTO SELECT MBOX IF MBOX COINS IS THE PAYMENT CURRENCY
                          value={refundRequest.paymentChannel}
                          onChange={(e) => {
                            handleRefundRequestChange(e, "paymentChannel");
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      {/* TODO: try to autoset what the payment is for */}
                      <span className="col-span-7">
                        Payment For
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <Textfield
                          placeholder={
                            "e.g., Overstay Fee, Storage Rental Fee, COD"
                          }
                          value={refundRequest.paymentFor}
                          maxLength={64}
                          onChange={(e) => {
                            handleRefundRequestChange(e, "paymentFor");
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-8">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        Proof of Payment
                        <span className="text-red-500"> *</span>
                      </span>
                      <span className="col-span-7">
                        <ImageTilePicker
                          key={imageKeys.proofOfPayment}
                          type={"file"}
                          maxWidth={1920}
                          maxHeight={1920}
                          maxSize={2}
                          accept="image/jpeg"
                          text="Upload Proof of Payment(JPG only)"
                          onChange={(event) => {
                            if (event.target.files && event.target.files[0]) {
                              imageToBase64(
                                event.target.files,
                                "proofOfPayment",
                                event
                              );
                            }
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
            <Divider className="border border-gray-200 col-span-12"></Divider>

            {/* refund details */}
            <>
              <div className="col-span-12 space-y-2">
                <div className="text-lg text-left text-secondary-purpleGray font-semibold py-2 rounded-md uppercase tracking-wide">
                  Refund Details
                </div>

                <div className="grid grid-cols-7 items-center">
                  <span className="col-span-7">
                    Requested Method of Refund{" "}
                    <span className="text-red-500">* </span>
                  </span>
                  <span className="col-span-7">
                    <Select
                      items={refundBankOptions}
                      defaultOption={{
                        value: -1,
                        name: "-- Select refund payment method -- ",
                      }}
                      value={refundRequest.refundMethod}
                      onChange={(e) => {
                        handleRefundRequestChange(e, "refundMethod");
                      }}
                    />
                  </span>
                </div>

                {refundRequest.refundMethod !== -1 &&
                  refundRequest.refundMethod !== "-1" && (
                    <div className="p-3 bg-slate-100 space-y-1 rounded-md">
                      <div className="grid grid-cols-7 items-center">
                        <span className="col-span-3">
                          Customer Account Name
                        </span>
                        <span className="col-span-4">
                          <Textfield
                            value={refundRequest.customerRefundDetails.name}
                            maxLength={64}
                            placeholder={
                              "Enter customer name as shown on their bank account"
                            }
                            onChange={(e) => {
                              handleRefundRequestChange(
                                e,
                                "customerRefundDetails.name"
                              );
                            }}
                          />
                        </span>
                      </div>
                      <div className="grid grid-cols-7 items-center">
                        <span className="col-span-3">
                          Customer{" "}
                          {getSelectedBankName(refundRequest.refundMethod)}{" "}
                          Account Number
                        </span>
                        <span className="col-span-4">
                          <Textfield
                            placeholder={
                              "Enter customer account number as shown on their bank account"
                            }
                            isNumberOnly={true}
                            value={
                              refundRequest.customerRefundDetails
                                .bankAccountNumber
                            }
                            maxLength={64}
                            onChange={(e) => {
                              handleRefundRequestChange(
                                e,
                                "customerRefundDetails.bankAccountNumber"
                              );
                            }}
                          />
                        </span>
                      </div>
                    </div>
                  )}

                <div className="grid grid-cols-7 items-center">
                  <span className="col-span-7">
                    Refund Request <span className="text-red-500"> *</span>
                  </span>
                  <span className="col-span-7">
                    <div className="flex gap-6 items-center">
                      <div className="flex items-center">
                        <RadioButtonV2
                          className="mr-2 "
                          labelSize="text-base"
                          value={`full`}
                          label="Full Refund"
                          checked={refundRequest.refundType === "full"}
                          onChange={(e) =>
                            handleRefundRequestChange(e, "refundType")
                          }
                        />
                      </div>
                      <div className="flex items-center">
                        <RadioButtonV2
                          className="mr-2"
                          labelSize="text-base"
                          value={`partial`}
                          label="Partial Refund"
                          checked={refundRequest.refundType !== "full"}
                          onChange={(e) =>
                            handleRefundRequestChange(e, "refundType")
                          }
                        />
                      </div>
                    </div>
                  </span>
                </div>

                <div className="grid grid-cols-8 items-center space-x-2">
                  <div className="col-span-4">
                    <span className="col-span-7">
                      Requested Refund Amount{" "}
                      <span className="text-red-500"> *</span>
                    </span>
                    <span className="col-span-7">
                      <Textfield
                        // isNumberOnly={true}
                        // maxLength={10}
                        className={`${
                          parseFloat(refundRequest.refundAmount) >
                          parseFloat(paymentData.paymentAmount)
                            ? "border-1 border-red-500 w-full"
                            : "w-full"
                        }`}
                        disabled={refundRequest.refundType === "full"}
                        value={
                          refundRequest.refundType === "full"
                            ? paymentData.paymentAmount
                            : refundRequest.refundAmount
                        }
                        onChange={(e) => {
                          handleRefundRequestChange(e, "refundAmount");
                        }}
                      />
                    </span>
                  </div>

                  <div className="col-span-4">
                    <span className="col-span-7 items-center">
                      Refund Currency
                      {/* <span className="text-blue-600 text-xs italic">
                        {" "}
                        (based on original payment currency)
                      </span> */}
                    </span>
                    <span className="col-span-7">
                      <Textfield
                        isNumberOnly={true}
                        disabled
                        value={
                          paymentData.paymentCurrency === "PHP"
                            ? "PHP"
                            : "MBOX COINS"
                        }
                      />
                    </span>
                  </div>
                  {parseFloat(refundRequest.refundAmount) >
                    parseFloat(paymentData.paymentAmount) && (
                    <div className="col-span-8 text-[14px] pt-2 italic text-red-500">
                      Refund amount cannot be greater than original payment
                      amount
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-7 items-center">
                  <span className="col-span-7">
                    Reason for Refund<span className="text-red-500"> *</span>
                  </span>
                  <span className="col-span-7">
                    <InputTextarea
                      placeholder="Please provide a detailed reason for the refund request..."
                      rows={3}
                      className="w-full max-h-[200px]"
                      maxLength={1000}
                      autoResize
                      pt={{
                        root: {
                          className: "border border-gray-200 p-1 rounded-md",
                        },
                      }}
                      value={refundRequest.refundReason}
                      onChange={(e) => {
                        handleRefundRequestChange(e, "refundReason");
                      }}
                    />
                    <p className="text-end">
                      {refundRequest.refundReason?.length}/{1000}
                    </p>
                  </span>
                </div>
              </div>
            </>
            <Divider className="border border-gray-200 col-span-12"></Divider>

            {/* personnel details */}
            <>
              <div className="col-span-12 space-y-2">
                <div className="text-lg text-left text-secondary-purpleGray font-semibold py-2 rounded-md uppercase tracking-wide">
                  Personnel Details
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">Personnel Username</span>
                      <span className="col-span-7">
                        <Textfield
                          disabled
                          value={refundRequest.personnelDetails?.username}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">Personnel Email</span>
                      <span className="col-span-7">
                        <Textfield
                          disabled
                          value={refundRequest.personnelDetails?.email}
                        />
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-8 space-x-2">
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">Requested On</span>
                      <span className="col-span-7">
                        <Textfield disabled value={refundRequest.requestedOn} />
                      </span>
                    </div>
                  </div>
                  <div className="col-span-4">
                    <div className="grid grid-cols-7 items-center">
                      <span className="col-span-7">
                        To be Approved By{" "}
                        <span className="text-red-500">*</span>
                      </span>
                      <span className="col-span-7">
                        <Select
                          items={techTeam}
                          defaultOption={{
                            value: -1,
                            name: "-- Select who will approve the request --",
                          }}
                          value={refundRequest.approvedBy}
                          onChange={(e) => {
                            handleRefundRequestChange(e, "approvedBy");
                          }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </>
      </Dialog>
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </>
  );
};

export default RefundDialog;
